import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { useParams} from 'react-router-dom';
import {getAxiosResponse, putOrPostAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp } from "../../services/Util";
import TreeView from "../../pages/TreeView";
import Constants from "../../Constants";
import { updateTreeValue, updateTreeData, addChildrenToTreeData } from "../../redux/reducers/TreeSlice";
import { updateCredentialsSet, updateProjectContentType } from "../../redux/reducers/ProjectInfoSlice"
import { transformBlankToNull } from '../../services/Util';
import ExactTargetCredential from "../../pages/settings/integrationSettings/ExactTargetCredential";
import jQuery from "jquery";
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../SuccessMessage";
import { logError } from "../../services/authApiRoutes/APImethods";
import { handleError } from "../../services/authApiRoutes/APImethods";

export default function ExactTargetIntegration () {

    const params = useParams();
    const dispatch = useDispatch();
    const TreeViewMemo = React.memo(TreeView);
    const ExactTargetCredentialMemo = React.memo(ExactTargetCredential);
    const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;

    const [credentialData, setCredentialData] = useState();
    const [serverErrorMessage, setServerErrorMessage] = useState([]);
    const [isValidating, setValidating] = useState(false);
    const [successMessage, setSuccessMessage] = useState();
    const [message, setMessage] = useState(Constants.BLANK);
    const [showCredential, setShowCredential] = useState(false);
    const [childData, setChildData] = useState();
    const [showTree, setShowTree] = useState(false);
    const [rule, setRule] = useState();

    const dispatchDataToTreeSliceRedux = (type, value) => {		
		dispatch(updateTreeValue({
		  type: type,
		  value: value
		}));
	}

    const showCredentialModel = () => {
        setShowCredential(true);
        document.body.classList.add("modal-open");
    };

    const hideCredentialModel = () => {
        setShowCredential(false);
        setValidating(false);
        document.body.classList.remove("modal-open");
    };

    useEffect(() => {
        getCredential(Constants.EXACTTARGET);
        getRules();
    }, []);

    const onTabChange = (tab) => {
        
    }

    const loadExactTargetTree = (contentType) => {
        setMessage("Please wait, your assets are being loaded...")
        dispatchDataToTreeSliceRedux("displayName", "assetName");
        dispatchDataToTreeSliceRedux("contentType", "ExactTarget");
        dispatchDataToTreeSliceRedux("isTreeLoading", true);
        getFolders(contentType);
    }

    useEffect(() => {
        const asset = treeValueRedux?.selectedTreeNode;
        if (asset?.assetId !== undefined) {
          if (asset?.assetType === Constants.CAMPAIGN) {
            getFolderChildren(asset.assetId, 0, 0, setChildData);
          } else {
            //getAssetChildren(asset.assetId, asset.assetType, 0, 0, setChildData);
          }
        }
    }, [treeValueRedux.selectedTreeNode])
    
    useEffect(() => {
        if (Array.isArray(childData) && childData.length > 0) {
          let cloneNode = JSON.parse(JSON.stringify(treeValueRedux.selectedTreeNode))
          cloneNode.children = childData;
          dispatch(addChildrenToTreeData(cloneNode))
        }
    }, [childData])

    const submitCredential = () => {
      setSuccessMessage("Validating credentials...")
      setValidating(true);
      var isPost = true;
      let localCredentialData = JSON.parse(JSON.stringify(credentialData));
      localCredentialData.credentials = {
        'CLIENT_ID': jQuery("#exacttarget-client-id-input").val(),
        'CLIENT_SECRET': jQuery("#exacttarget-client-secret-input").val(),
        'SUB_DOMAIN': jQuery("#exacttarget-sub-domain-input").val()
    };
    localCredentialData.credentialsType = "EXACTTARGET"
      if(localCredentialData?.id){
        isPost = false;
      }
      putOrPostAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.EXACTTARGET), localCredentialData, isPost
        ).then((res) => {
          setValidating(false);
          setSuccessMessage(Constants.BLANK)
          if (res.data?.handledMessage || res.data?.data?.handledMessage){
            setServerErrorMessage([res.data.handledMessage])
          } else {
            setServerErrorMessage([])
            setSuccessMessage("Credential successfully updated!")
          }
        }).catch((err) => {
          setValidating(false);
          const errorMessage =   "err - ";
          logError(errorMessage, err);    
          setSuccessMessage(Constants.BLANK)
      })
    }

    const getCredential = (service) => {
      setValidating(true)
      setMessage("Checking credentials...")
      const dateTimestamp = dateConvertToTimeStamp();
      getAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(service) + `?_=${dateTimestamp}`
      ).then (res => {
        setValidating(false)
        setMessage(Constants.BLANK)
        if (res.data.code === 200) {
          var credentialsSet = transformBlankToNull(res.data.data.body)
          setCredentialData(credentialsSet)
          dispatch(updateCredentialsSet(credentialsSet))
            dispatch(updateProjectContentType(Constants.EXACTTARGET));
          if (credentialsSet !== null && credentialsSet.credentials !== null) {
            loadExactTargetTree();
          } else {
            showCredentialModel();
          }
        }
      }).catch(err => {
        setMessage(Constants.BLANK)
        handleError(err);
        setValidating(false)
      });
    };

    const getFolders = (contentType) => {
        setValidating(true);
        setMessage("Fetching data...")
        const dateTimestamp = dateConvertToTimeStamp();
        getAxiosResponse(APIUrls.EXACTTARGET_FOLDERS(contentType, params.id) + `?_=${dateTimestamp}`
        ).then(res => {
            setValidating(false);
            dispatchDataToTreeSliceRedux("isTreeLoading", false);
            setMessage(Constants.BLANK)
            if (res.data.code === 200) {
                let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
                dispatch(updateTreeData(assetList))  
              } else {
                showCredentialModel();
              }
        }).catch(err => {
            setValidating(false);
            dispatchDataToTreeSliceRedux("isTreeLoading", false);
            setMessage(Constants.BLANK)
        })
    }

    const getFolderChildren = (contentType, folderId, setValue) => {
        const dateTimestamp = dateConvertToTimeStamp();
        dispatchDataToTreeSliceRedux("isTreeLoading", true);
        getAxiosResponse(
          APIUrls.EXACTTARGET_FOLDER_CONTENT(contentType, params.id, folderId) + `?folderId=${folderId}&_=${dateTimestamp}`
        ).then((res) => {
          dispatchDataToTreeSliceRedux("isTreeLoading", false);
            if (res.data.code === 200) {
              let assetList = convertAssets(res.data.data.body.assetTypeResponseList);
              setValue(assetList);
            }
        }).catch((err) => {
          dispatchDataToTreeSliceRedux("isTreeLoading", false);
          handleError(err);
        });
    };

    const getRules = () => {
      const dateTimestamp = dateConvertToTimeStamp();
      getAxiosResponse(APIUrls.EXACTTARGET_DATA_EXTENSIONS_DEFAULT + `?_=${dateTimestamp}`
      ).then(res => {
        if (res.data.code === 200) {
          var rule = transformBlankToNull(res.data.data)
          setRule(rule)
        }
      }).catch(err => {
        handleError(err);
      });   
    };

    const convertAssets = (assetTypeResponseList) => {
      let assets = transformBlankToNull(assetTypeResponseList)
      let assetList = [];
      assets?.map(asset => {
        asset.assetList.map(a => {
          a.assetType = asset.assetType;
          a.id = a.assetId;
          a.children = [];
          a.parentAssetUrl = treeValueRedux.selectedTreeNode?.assetUrl;
          a.parentAssetType = treeValueRedux.selectedTreeNode?.assetType;
          assetList.push(a)
        }); 
      })
      return assetList;
    }

    return (
        <>
          <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
          <div className="gb-loader">
              <RotatingLines
                  strokeColor="#0096FF"
                  strokeWidth="5"
                  width="196"
                  visible={true}
              />
              </div>
          </div> 
          {(message!==undefined && message !== Constants.BLANK)?<SuccessMessage message={message}/>:Constants.BLANK}

        {!showTree ? (
        <div className="show create-project-section">
        <div className="step-1-section">
          <div className="project-heading">
            <h3>Who will translate this project? </h3>
            <label>
            Which type of ExactTarget content would you like to translate? <sup>*</sup>
            </label>
          </div>
          <div className="marketo-default-wrap">
            <div
              className="marketo-default-list flex-center"
              role="button"
              aria-label="New Asset"
              tabindex="0"
            >
              <div className="left flex-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="30"
                  viewBox="0 0 32 30"
                  fill="none"
                >
                  <path
                    d="M31 13V5H14L10 1H1V27H13"
                    stroke="#2A4274"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M14 5H8"
                    stroke="#2A4274"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M10 1H19L23 5"
                    stroke="#2A4274"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M23 29C27.4183 29 31 25.4183 31 21C31 16.5817 27.4183 13 23 13C18.5817 13 15 16.5817 15 21C15 25.4183 18.5817 29 23 29Z"
                    stroke="#2A4274"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M23 17V25"
                    stroke="#2A4274"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M27 21H19"
                    stroke="#2A4274"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="right" onClick={() => loadExactTargetTree(Constants.EMAIL_CODE)}>
                <strong> Emails </strong>
                <p>Each ExactTarget email selected will get a new translated copy per language.</p>
              </div>
            </div>
            <div
              className="marketo-default-list flex-center"
              role="button"
              aria-label="Dynamic Content"
              tabindex="0"
            >
              <div className="left flex-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="30"
                  viewBox="0 0 32 30"
                  fill="none"
                >
                  <path
                    d="M30 6H28V4C28 3.46957 27.7893 2.96086 27.4142 2.58579C27.0391 2.21071 26.5304 2 26 2H16V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1L0 28C0 28.5304 0.210714 29.0391 0.585786 29.4142C0.960859 29.7893 1.46957 30 2 30H30C30.5304 30 31.0391 29.7893 31.4142 29.4142C31.7893 29.0391 32 28.5304 32 28V8C32 7.46957 31.7893 6.96086 31.4142 6.58579C31.0391 6.21071 30.5304 6 30 6ZM26 4V6H16V4H26ZM30 28H2V2H14V6H5V8H30V28Z"
                    fill="#2A4274"
                  ></path>
                  <path
                    d="M11.9991 18C11.8675 17.9992 11.737 18.0245 11.6152 18.0742C11.4933 18.124 11.3825 18.1973 11.2891 18.29L7.28906 22.29L8.69906 23.7L12.4091 20H17.9991C18.1307 20.0008 18.2611 19.9755 18.383 19.9258C18.5048 19.876 18.6156 19.8027 18.7091 19.71L22.9991 15.41V18H24.9991V13C24.9991 12.7348 24.8937 12.4804 24.7062 12.2929C24.5186 12.1054 24.2643 12 23.9991 12H18.9991V14H21.5891L17.5891 18H11.9991Z"
                    fill="#2A4274"
                  ></path>
                </svg>
              </div>
              <div className="right" onClick={() => loadExactTargetTree(Constants.DATAEXTENSION)}>
                <strong> Data Extensions </strong>
                <p>Translations will be delivered to pre-configured Box Data Extensions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      ) : (
        <div>
            <TreeViewMemo onTabChange={onTabChange} />
        </div>
      )}

      {showCredential && 
      <div className="lightbox-panel sm-lg-lightbox-panel">
      <div className="inner-lightbox-panel pb-0">
      <div className="modal-header flex padd-lr">
      <strong>ExactTarget API Settings</strong>
      <button className="close" aria-label="close popup" onClick={() => hideCredentialModel()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
      </button>
      </div>
      <div className="lightbox-content padd-22">
          <div className="flex">
          <div className="leftBlock">
              <p>Manage your ExactTarget login credentials for ExactTarget Integration projects.</p>
              <p>OPAL-Marketing accelerates and automates the localization process by integrating directly with ExactTarget. 
                The content can subsequently be translated into the desired languages and an in-context review can take 
                place allowing reviewers to edit and comment on the content. After the translations have been approved, 
                OPAL-Marketing automatically updates ExactTarget with the translated emails.</p>
          </div>
          <div className="rightBlock">
          <div className="flex wrap-dropdown flex-column mb-0">
            <ExactTargetCredentialMemo 
              credentialData = {credentialData} 
              errorMessages = {serverErrorMessage}
              isValidating = {isValidating}
              successMessage = {successMessage} 
              closePopup = {hideCredentialModel}
            />
          </div>
          </div>
          </div>
      </div>	
      <div className="modal-footer modal-footer-border flex px-22">
          <button className="btn btn-bold" onClick={() => hideCredentialModel()}>Cancel</button>
          <button id="save-credential" className="btn btn-bold active" onClick={() => submitCredential()}>Save</button>
      </div>
      </div>		
      </div>
    }
  </>
    )
}